import { Image } from 'lucide-react';
import { FilterChip } from '@/mobile/shared/FilterChip';
import type { DocType } from './types';

const DOC_TYPES: { id: DocType; label: string }[] = [
  { id: 'nfe', label: 'NFe' },
  { id: 'recibo', label: 'Recibo' },
  { id: 'boleto', label: 'Boleto' },
  { id: 'extrato', label: 'Extrato' },
];

export { DOC_TYPES };

interface ScanViewfinderControlsProps {
  docType: DocType;
  onDocTypeChange: (dt: DocType) => void;
  onCapture: () => void;
  onGallery: () => void;
}

/**
 * Controles inferiores do viewfinder:
 * doc-type chips + galeria/captura/placeholder.
 */
export function ScanViewfinderControls({
  docType,
  onDocTypeChange,
  onCapture,
  onGallery,
}: ScanViewfinderControlsProps) {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 24px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        zIndex: 10,
      }}
    >
      {/* Doc-type chips */}
      <div
        role="group"
        aria-label="Tipo de documento"
        style={{
          display: 'flex',
          gap: 8,
          justifyContent: 'center',
          overflowX: 'auto',
          padding: '0 20px',
          scrollbarWidth: 'none',
        }}
      >
        {DOC_TYPES.map((d) => (
          <FilterChip
            key={d.id}
            active={docType === d.id}
            onClick={() => onDocTypeChange(d.id)}
          >
            {d.label}
          </FilterChip>
        ))}
      </div>

      {/* Galeria | Captura | Espaço */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          padding: '0 36px',
        }}
      >
        <button
          onClick={onGallery}
          aria-label="Escolher imagem da galeria"
          style={{ ...iconBtnStyle, justifySelf: 'start' }}
        >
          <Image size={20} strokeWidth={1.7} aria-hidden />
        </button>

        <button
          onClick={onCapture}
          aria-label="Capturar documento"
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.18)',
            display: 'grid',
            placeItems: 'center',
            border: 'none',
            cursor: 'pointer',
            justifySelf: 'center',
          }}
        >
          <span
            style={{
              width: 58,
              height: 58,
              borderRadius: '50%',
              background: 'linear-gradient(160deg, #6FAE93, var(--mint-deep))',
              border: '3px solid #fff',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4)',
              display: 'block',
            }}
          />
        </button>

        <span style={{ justifySelf: 'end', width: 44, height: 44 }} aria-hidden="true" />
      </div>
    </div>
  );
}

const iconBtnStyle: React.CSSProperties = {
  width: 44,
  height: 44,
  borderRadius: '50%',
  background: 'rgba(255,255,255,0.14)',
  border: '1px solid rgba(255,255,255,0.2)',
  color: '#fff',
  display: 'grid',
  placeItems: 'center',
  cursor: 'pointer',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
};
